import _ from "lodash";

export default {
    state: {
        list: null,
        listToFilter: null,
        count: null,
        single: null,
        devices: null,
        youtubeApiKey: null,
        isAllCampaigns: null,

        filters: {
            search: "",
            orderBy: "data_ultima_alteracao",
            desc: true,
            //fix it - tirar isso \
            thirdParty: false,
            isLevels: false,
            level: 1,
            archived: false
        }
    },

    getters: {
        mappedAdvertisingDevices(state) {
            const devices = state.devices;

            let establishments = _.uniqBy(devices, device => {
                return device.estabelecimentoId;
            });

            establishments = _.map(establishments, place => {
                return {
                    id: `est-${place.estabelecimentoId}`,
                    label: place.estabelecimentoNome,
                    selected: place.isTodosAparelhos,
                    children: []
                };
            });

            _.forEach(devices, device => {
                const where = _.find(establishments, place => {
                    return `est-${device.estabelecimentoId}` === place.id;
                });

                device = {
                    id: device.aparelhoId,
                    label: device.aparelhoNome || device.aparelhoId,
                    selected: device.selecionado
                };

                where.children.push(device);
            });

            return establishments;
        }
    },

    mutations: {
        ADVERTISING_SET_LIST(state, payload) {
            state.list = payload;
        },

        ADVERTISING_SET_LIST_FILTER(state, payload) {
            state.listToFilter = payload;
        },

        ADVERTISING_SET_COUNT(state, payload) {
            state.count = payload;
        },

        ADVERTISING_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },

        ADVERTISING_SET_ALL_CAMPAIGNS(state, value ){
            state.isAllCampaigns = value
        },

        SET_SINGLE_ADVERTISING(state, payload) {
            state.single = payload;
        },

        SET_ADVERTISING_DEVICES(state, devices) {
            state.devices = devices;
        },

        SET_ADVERTISING_YT_API_KEY(state, key) {
            state.youtubeApiKey = key
        }
    }
};
